import React from 'react';

import SEO from '../../components/SEO';
import DescriptionSection from '../../components/pages/services/analysis/DescriptionSection';
import GetStartedSection from '../../components/pages/GetStartedSection';
import ConfigurationsSection from '../../components/pages/services/analysis/ConfigurationsSection';

const seo = {
  title: 'Business Analysis Services',
  description:
    '',
};
const Hub = () => {
  return (
    <>
      <SEO title={seo.title} description={seo.description} />
      <DescriptionSection />
      {/* <ConfigurationsSection />
      <GetStartedSection demoPathname="/learn/how-to-guides/using-add-ons/enterprise/influxdb/connect-and-use-ockam-hub" /> */}
    </>
  );
};

export default Hub;
